export const D3_TRANSITION_DURATION = 300;
export const LINE_TOOLTIP_WIDTH = 180;
export const LINE_TOOLTIP_HEIGHT = 70;
export const LINE_TOOLTIP_PADDING = 15;
export const DEFAULT_ROLLING_DAYS = 7;
